/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckFooter from './CheckFooter';
import CheckContent from './CheckContent';
import classes from './CheckCard.module.css';

const CheckCard = (props) => {
  const {
    check,
    onSelectCheck,
    isSelected,
    rowIndex,
    managerMode,
    currency,
    fbVenueMode,
  } = props;

  const onClickCard = () => {
    onSelectCheck && onSelectCheck(check, rowIndex);
  };

  return (
    <div
      className={classNames({ [classes.checkCard]: true, [classes.selected]: isSelected })}
      onClick={onClickCard}
    >
      <div className={classes.cardWrapper}>
        <CheckContent
          check={check}
          managerMode={managerMode}
          fbVenueMode={fbVenueMode}
        />
        <CheckFooter
          check={check}
          managerMode={managerMode}
          currency={currency}
        />
      </div>
    </div>
  );
};

export default CheckCard;

CheckCard.propTypes = {
  check: PropTypes.object,
  onSelectCheck: PropTypes.func,
  isSelected: PropTypes.bool,
  rowIndex: PropTypes.number,
  managerMode: PropTypes.bool,
  currency: PropTypes.string,
  fbVenueMode: PropTypes.bool,
};

CheckCard.defaultProps = {
  check: {},
  onSelectCheck: () => { },
  isSelected: false,
  managerMode: false,
  currency: '$',
  fbVenueMode: false,
};
